import type React from "react";
import { FormattedHTMLMessage } from "react-intl";

import { isCollectStep } from "../../lib/types/runtimeTypes";
import { type VerificationStep } from "../../lib/types/types";

interface Props {
  step: VerificationStep;
}

// eslint-disable-next-line react/prop-types
const LoadingScreenMessage: React.FC<Props> = ({ step }) => (
  <div className="sid-loading-screen__message">
    {isCollectStep(step) && (
      <div className="sid-loading-screen__message-header" role="alert">
        <FormattedHTMLMessage
          id="step.personalInfo.verifyingTitle"
          defaultMessage="Verifying your status"
        />
      </div>
    )}

    <div className="sid-loading-screen__message-subhead">
      <FormattedHTMLMessage
        id="step.personalInfo.verifyingSubtitle"
        defaultMessage="This should only take a minute"
      />
    </div>
  </div>
);

export default LoadingScreenMessage;
